import { useSiteConfig } from "@/context/SiteConfigContext";
import Hero from "@/components/site/Hero";
import MediaPresence from "@/components/site/MediaPresence";
import Principles from "@/components/site/Principles";
import HomeServices from "@/components/site/HomeServices";
import HomeWorks from "@/components/site/HomeWorks";
import HomeCourses from "@/components/site/HomeCourses";
import HomeJournal from "@/components/site/HomeJournal";
import KooltExecutionArm from "@/components/site/KooltExecutionArm";
import CustomSection from "@/components/site/CustomSection";

const REGISTRY = {
  home_services: HomeServices,
  koolt: KooltExecutionArm,
  home_works: HomeWorks,
  home_courses: HomeCourses,
  home_journal: HomeJournal,
  media: MediaPresence,
  principles: Principles,
};

export default function Home() {
  const { config } = useSiteConfig();
  const order = config?.sections?.order || [];
  const items = config?.sections?.items || {};
  const heroVisible = items.hero?.visible !== false;

  return (
    <>
      {heroVisible && <Hero />}
      {order.map((key) => {
        const it = items[key];
        if (!it || it.visible === false) return null;
        if (it.type === "custom")
          return <CustomSection key={key} id={key} />;
        const Comp = REGISTRY[key];
        return Comp ? <Comp key={key} /> : null;
      })}
    </>
  );
}
